import { render } from "./DialogConfirmChangeLanguage.vue?vue&type=template&id=4c484877&scoped=true&ts=true"
import script from "./DialogConfirmChangeLanguage.ts?vue&type=script&lang=ts"
export * from "./DialogConfirmChangeLanguage.ts?vue&type=script&lang=ts"

import "./DialogConfirmChangeLanguage.scss?vue&type=style&index=0&id=4c484877&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c484877"]])

export default __exports__